
import './App.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Contact from './components/contact';
import AboutUs from './components/aboutUs';
import Home from './components/home';
import Blog from './components/blog';
import Training from './components/training';
import Consulting from './components/consulting';
import UsefulLinks from './components/usefulLinks';
import TermsOfUse from './components/termsOfUse';
import Faq from './components/faq';
import PrivacyPolicy from './components/PrivacyPolicy';
import React, { useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Form from './components/form';
import Section1 from './components/section1';
import Section2 from './components/section2';
import PhotoG from './components/photoGallery.jsx';
import CRAGallery from './components/gallery/CRAGallery.jsx';
import ORMMasterclass2025Gallery from './components/gallery/ORMMasterclass2025Gallery.jsx';

function App() {
    const [language, setLanguage] = useState('eng');
   // const [sections, setSections] = useState({'section1': '/training/section1', 'section2': '/training/section2'});
  // const [activeSection, setActiveSection] = useState(null);

  // const handleScroll = () => {
  //   const sections = document.querySelectorAll("section");
  //   let currentSection = null;

  //   sections.forEach((section) => {
  //     const rect = section.getBoundingClientRect();
  //     if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
  //       currentSection = section.id;
  //     }
  //   });

  //   setActiveSection(currentSection);
  // };

  // useEffect(() => {
  //   // Initialize Scrollspy manually after the page has loaded
  //   const scrollSpyElement = document.getElementById("navbar");
  //   if (scrollSpyElement && window.bootstrap) {
  //     new window.bootstrap.ScrollSpy(scrollSpyElement, {
  //       target: '#navbar'
  //     });
  //   }

  //   window.addEventListener("scroll", handleScroll);
  
  //     return () => {
  //       window.removeEventListener("scroll", handleScroll);
  //     };
  //   }, []);
    const changeLanguage=(lang)=>{
        setLanguage(lang);
        console.log(lang);
    }
    const englanguage = ()=>{
        if (language === 'eng'){
            return '';
        }else{
            return 'd-none';
        }
    }
    const geolanguage = ()=>{
        if (language === 'geo'){
            return '';
        }else{
            return 'd-none';
        }
    }
    const fontFamily=()=>{
        if (language === 'eng'){
            return 'arial';
        }else{
            return 'notoSansGeorgian';
        }
    }
    
  return (
    <>
        <div style={{backgroundColor: '#F0F0F0',fontFamily: fontFamily(), color: '#003968'}} >
            <Router>
                <Routes>
                    <Route
                        exact
                        path="/"
                        element={<Home 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />
                        }
                    />
                    <Route
                        path="/aboutus"
                        element={<AboutUs 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/contact"
                        element={<Contact 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/blog"
                        element={<Blog 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/training"
                        element={<Training 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/training/operational_risk"
                        element={<Section1
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/training/risk_management_for_microfinance"
                        element={<Section2
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/consulting"
                        element={<Consulting 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/usefulLinks"
                        element={<UsefulLinks 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/termsOfUse"
                        element={<TermsOfUse 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/privacyPolicy"
                        element={<PrivacyPolicy 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/faq"
                        element={<Faq 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/form"
                        element={<Form 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/gallery"
                        element={<PhotoG 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/gallery/CRAGallery"
                        element={<CRAGallery 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    <Route
                        path="/gallery/ORMMasterclass2025Gallery"
                        element={<ORMMasterclass2025Gallery 
                            onlanguage={language}
                            onChangeLanguage={changeLanguage}
                            onGeoLanguage={geolanguage}
                            onEngLanguage={englanguage} />}
                    />
                    {/* If any route mismatches the upper 
          route endpoints then, redirect triggers 
          and redirects app to home component with to="/" */}
                    {/* <Redirect to="/" /> */}
                    <Route
                        path="*"
                        element={<Navigate to="/" />}
                    />
                </Routes>
            </Router>
            </div>
            
        </>
  );
}

export default App;
